import { compose, withHandlers, withState, withProps } from 'recompose'
import { connect } from 'react-redux'
import ValuePropositionWrapper from './ValuePropositionWrapper'
import { showNewShopTiresModal } from 'components/NewShopTiresModal/actions'
import withRequestApptClick from 'components/common/hoc/withRequestApptClick'
import { SCHEDULE_APPOINTMENT, REQUEST_APPOINTMENT, TAB_TIRE_SIZE_NAME, YMME_NAME } from 'constant'
import withNavigateToTireSearchOrShowYmme from 'components/common/hoc/withNavigateToTireSearchOrShowYmme'
import withShowConfirmTireSizeModalPreconfigured from 'components/common/hoc/withShowConfirmTireSizeModalPreconfigured'
import withTrailerFlags from 'components/common/hoc/withTrailerFlags'
import { getCurrentStoreIsE2EAppointment } from 'selectors/getCurrentStore'
import { INITIAL_HOVER_DATA } from '../../../constant'
import { isDesktop } from 'components/common/Media/helpers'

const withHoverState = withState('hover', 'setHover', INITIAL_HOVER_DATA)

const mapStateToProps = (state) => ({
  isE2EAppointment: getCurrentStoreIsE2EAppointment(state)
})

const withValuePropositionHandlers = withHandlers({
  onMouseEnterHandler: ({ setHover, isDesktop }) => (alt) => {
    isDesktop && setHover({
      ...INITIAL_HOVER_DATA,
      [alt]: true
    })
  },
  onMouseLeaveHandler: ({ setHover, isDesktop }) => () => {
    isDesktop && setHover(INITIAL_HOVER_DATA)
  },
  showNewYMMEModal: ({
    showNewShopTiresModal,
    hasActiveVehicle,
    isTrailer,
    navigateToTireSearchOrShowYmme
  }) => () => {
    (hasActiveVehicle && !isTrailer)
      ? navigateToTireSearchOrShowYmme()
      : showNewShopTiresModal({ ymmeName: YMME_NAME })
  },
  showNewTireSizeModal: ({
    showNewShopTiresModal,
    activeVehicle,
    navigateToSearchByTireSizes
  }) => () => {
    const { frontTireSize } = activeVehicle

    frontTireSize
      ? navigateToSearchByTireSizes(activeVehicle)
      : showNewShopTiresModal({ ymmeName: YMME_NAME, tabName: TAB_TIRE_SIZE_NAME })
  },
  goToRequestAppointmentFlow: ({ onClick }) => (e) => {
    e.preventDefault()
    onClick(e)
  }
})

const withInfo = withProps(({ isE2EAppointment, showNewYMMEModal, onClick }) => ({
  appointmentTitle: isE2EAppointment ? SCHEDULE_APPOINTMENT.toUpperCase() : REQUEST_APPOINTMENT.toUpperCase(),
  handleShopByVehicleClick: onClick || showNewYMMEModal
}))

const withIsDesktop = withProps(() => ({
  isDesktop: isDesktop()
}))

export default compose(
  connect(mapStateToProps, { showNewShopTiresModal }),
  withProps(() => ({ navigateToQuickApptPage: true })),
  withTrailerFlags,
  withHoverState,
  withNavigateToTireSearchOrShowYmme,
  withRequestApptClick,
  withIsDesktop,
  withValuePropositionHandlers,
  withShowConfirmTireSizeModalPreconfigured,
  withInfo
)(ValuePropositionWrapper)
